var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v(_vm._s(_vm.$attrs["v-model"].sectionName))]),
      _c("div", [
        _c(
          "div",
          [
            _c("el-checkbox", {
              attrs: { label: "Repeatable section" },
              model: {
                value: _vm.$attrs["v-model"].repeatable,
                callback: function ($$v) {
                  _vm.$set(_vm.$attrs["v-model"], "repeatable", $$v)
                },
                expression: "$attrs['v-model'].repeatable",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Section Name")]),
            _c("el-input", {
              attrs: { maxlength: "50", placeholder: "Section Name" },
              model: {
                value: _vm.$attrs["v-model"].sectionName,
                callback: function ($$v) {
                  _vm.$set(_vm.$attrs["v-model"], "sectionName", $$v)
                },
                expression: "$attrs['v-model'].sectionName",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Display Name")]),
            _c("el-input", {
              attrs: { maxlength: "50", placeholder: "Enter Display Name" },
              model: {
                value: _vm.$attrs["v-model"].displayName,
                callback: function ($$v) {
                  _vm.$set(_vm.$attrs["v-model"], "displayName", $$v)
                },
                expression: "$attrs['v-model'].displayName",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Heading")]),
            _c("el-input", {
              attrs: { maxlength: "50", placeholder: "Enter a Heading" },
              model: {
                value: _vm.$attrs["v-model"].heading,
                callback: function ($$v) {
                  _vm.$set(_vm.$attrs["v-model"], "heading", $$v)
                },
                expression: "$attrs['v-model'].heading",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Description")]),
            _c("el-input", {
              attrs: {
                rows: 3,
                type: "textarea",
                placeholder: "Enter a Description",
              },
              model: {
                value: _vm.$attrs["v-model"].description,
                callback: function ($$v) {
                  _vm.$set(_vm.$attrs["v-model"], "description", $$v)
                },
                expression: "$attrs['v-model'].description",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v("Help Description")]),
            _c("el-input", {
              attrs: {
                rows: 3,
                type: "textarea",
                placeholder: "Enter a Help Description",
              },
              model: {
                value: _vm.$attrs["v-model"].helpDescription,
                callback: function ($$v) {
                  _vm.$set(_vm.$attrs["v-model"], "helpDescription", $$v)
                },
                expression: "$attrs['v-model'].helpDescription",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("el-checkbox", {
              attrs: { label: "Menu Shortcut" },
              model: {
                value: _vm.$attrs["v-model"].menuShortcut,
                callback: function ($$v) {
                  _vm.$set(_vm.$attrs["v-model"], "menuShortcut", $$v)
                },
                expression: "$attrs['v-model'].menuShortcut",
              },
            }),
          ],
          1
        ),
        _c(
          "span",
          [
            _c("small", [_vm._v(" Parent ")]),
            _c(
              "el-select",
              {
                on: { change: _vm.updateParent },
                model: {
                  value: _vm.$attrs["v-model"].parentId,
                  callback: function ($$v) {
                    _vm.$set(_vm.$attrs["v-model"], "parentId", $$v)
                  },
                  expression: "$attrs['v-model'].parentId",
                },
              },
              _vm._l(
                _vm.appSteps.filter(function (_appStep) {
                  return _appStep.appStepId !== _vm.$attrs["v-model"].appStepId
                }),
                function (appStep) {
                  return _c("el-option", {
                    key: appStep.appStepId,
                    attrs: {
                      label: appStep.displayName,
                      value: appStep.appStepId,
                    },
                  })
                }
              ),
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-tabs",
        {
          attrs: { id: "pagesTab", tabPosition: "left", addable: true },
          on: {
            "tab-add": function ($event) {
              _vm.newPageModal = true
            },
          },
          model: {
            value: _vm.activePage,
            callback: function ($$v) {
              _vm.activePage = $$v
            },
            expression: "activePage",
          },
        },
        [
          _vm._l(
            Array.from(
              new Set(
                _vm.$attrs["v-model"].fields.map(function (field) {
                  return field.pageNumber.toString()
                })
              )
            ),
            function (page, index) {
              return _c(
                "el-tab-pane",
                { key: index, attrs: { label: "Page " + page, name: page } },
                [
                  _c("div", { attrs: { id: "fieldsSection" } }, [
                    _c(
                      "div",
                      { staticClass: "fields-list" },
                      [
                        _c("small", [_vm._v("Fields:")]),
                        _c(
                          "ul",
                          _vm._l(
                            _vm.$attrs["v-model"].fields
                              .filter(function (field) {
                                return (
                                  field.pageNumber.toString() ===
                                    _vm.activePage && field.delete !== true
                                )
                              })
                              .sort(function (a, b) {
                                return a.sortOrder - b.sortOrder
                              }),
                            function (field, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  staticClass: "field-list-item",
                                  style:
                                    "" +
                                    (_vm.activeField !== null &&
                                    field.appFieldId ===
                                      _vm.activeField.appFieldId
                                      ? "background: #324154; color: white"
                                      : ""),
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateActiveField(field)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        field.appFieldName +
                                          " #" +
                                          field.appFieldId
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.addFieldModal = true
                              },
                            },
                          },
                          [_vm._v(" Add Field ")]
                        ),
                      ],
                      1
                    ),
                    _vm.activeField
                      ? _c("div", { attrs: { id: "activeField" } }, [
                          _c("small", [_vm._v("Selected Field")]),
                          _c(
                            "span",
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.activeField.appFieldId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.activeField, "appFieldId", $$v)
                                  },
                                  expression: "activeField.appFieldId",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Enter a Display Name" },
                                model: {
                                  value: _vm.activeField.displayNameCapture,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.activeField,
                                      "displayNameCapture",
                                      $$v
                                    )
                                  },
                                  expression: "activeField.displayNameCapture",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Enter an Assoicated OrderField",
                                },
                                model: {
                                  value: _vm.activeField.associatedOrderField,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.activeField,
                                      "associatedOrderField",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "activeField.associatedOrderField",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Enter an Assoicated OrderField",
                                },
                                model: {
                                  value: _vm.activeField.fieldType.displayName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.activeField.fieldType,
                                      "displayName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "activeField.fieldType.displayName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            [
                              _c("el-input", {
                                attrs: {
                                  rows: 3,
                                  type: "textarea",
                                  placeholder: "Enter a Description",
                                },
                                model: {
                                  value: _vm.activeField.description,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.activeField,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "activeField.description",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            [
                              _c("el-input", {
                                attrs: {
                                  rows: 3,
                                  type: "textarea",
                                  placeholder: "Enter a Help Description",
                                },
                                model: {
                                  value: _vm.activeField.helpDescription,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.activeField,
                                      "helpDescription",
                                      $$v
                                    )
                                  },
                                  expression: "activeField.helpDescription",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  placeholder: "Page Number",
                                },
                                model: {
                                  value: _vm.activeField.pageNumber,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.activeField, "pageNumber", $$v)
                                  },
                                  expression: "activeField.pageNumber",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "number",
                                  placeholder: "Sort Order",
                                },
                                model: {
                                  value: _vm.activeField.sortOrder,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.activeField, "sortOrder", $$v)
                                  },
                                  expression: "activeField.sortOrder",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("span", [
                            _vm._v(" Related fields: "),
                            _c("div", { staticClass: "fields-list" }, [
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.activeField.relatedFields,
                                  function (field) {
                                    return _c(
                                      "li",
                                      {
                                        key: field.appFieldId,
                                        staticClass: "field-list-item",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              field.appFieldName +
                                                " #" +
                                                field.appFieldId
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                          _c("span", [
                            _vm._v(" Children Group: "),
                            _c("div", { staticClass: "fields-list" }, [
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.activeField.childrenGroup,
                                  function (field) {
                                    return _c(
                                      "li",
                                      {
                                        key: field.appFieldId,
                                        staticClass: "field-list-item",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              field.appFieldName +
                                                " #" +
                                                field.appFieldId
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                          _c(
                            "span",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger" },
                                  on: { click: _vm.removeField },
                                },
                                [_vm._v(" Remove Field ")]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _c("span", [_vm._v(" No Field selected ")]),
                  ]),
                ]
              )
            }
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.addFieldModal,
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.addFieldModal = $event
                },
                close: _vm.closeModal,
              },
            },
            [
              _vm._v(" Add Field "),
              _c(
                "el-select",
                {
                  attrs: { multiple: false, placeholder: "Selected Fields" },
                  model: {
                    value: _vm.newAppField,
                    callback: function ($$v) {
                      _vm.newAppField = $$v
                    },
                    expression: "newAppField",
                  },
                },
                _vm._l(_vm.allAppFields, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: item.appFieldName + " #" + item.appFieldId,
                      value: item,
                    },
                  })
                }),
                1
              ),
              _c(
                "el-button",
                { attrs: { type: "success" }, on: { click: _vm.addField } },
                [_vm._v(" Add ")]
              ),
              _c("el-button", { on: { click: _vm.closeModal } }, [
                _vm._v(" Cancel "),
              ]),
            ],
            1
          ),
          Array.from(
            new Set(
              _vm.$attrs["v-model"].fields.map(function (field) {
                return field.pageNumber.toString()
              })
            )
          ).length < 1
            ? _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.initialFieldModal = true
                    },
                  },
                },
                [_vm._v(" Add Initial Field ")]
              )
            : _vm._e(),
          _c(
            "el-dialog",
            {
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.initialFieldModal,
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.initialFieldModal = $event
                },
                close: _vm.closeModal,
              },
            },
            [
              _vm._v(" Initial Field "),
              _c(
                "el-select",
                {
                  attrs: { multiple: false, placeholder: "Selected Fields" },
                  model: {
                    value: _vm.initialAppField,
                    callback: function ($$v) {
                      _vm.initialAppField = $$v
                    },
                    expression: "initialAppField",
                  },
                },
                _vm._l(_vm.allAppFields, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: item.appFieldName + " #" + item.appFieldId,
                      value: item,
                    },
                  })
                }),
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.addPage()
                    },
                  },
                },
                [_vm._v(" Add ")]
              ),
              _c("el-button", { on: { click: _vm.closeModal } }, [
                _vm._v(" Cancel "),
              ]),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.newPageModal,
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.newPageModal = $event
                },
                close: _vm.closeModal,
              },
            },
            [
              _vm._v(" Initial New Page Field "),
              _c(
                "el-select",
                {
                  attrs: { multiple: false, placeholder: "Selected Fields" },
                  model: {
                    value: _vm.initialAppField,
                    callback: function ($$v) {
                      _vm.initialAppField = $$v
                    },
                    expression: "initialAppField",
                  },
                },
                _vm._l(_vm.allAppFields, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: item.appFieldName + " #" + item.appFieldId,
                      value: item,
                    },
                  })
                }),
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: {
                    click: function ($event) {
                      _vm.addPage(_vm.lastPage() + 1)
                    },
                  },
                },
                [_vm._v(" Add ")]
              ),
              _c("el-button", { on: { click: _vm.closeModal } }, [
                _vm._v(" Cancel "),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _vm._m(0),
      _vm.$attrs["v-model"].childrenPlaceholder
        ? _c(
            "div",
            { staticClass: "children" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "demo-tabs",
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeAppStep,
                    callback: function ($$v) {
                      _vm.activeAppStep = $$v
                    },
                    expression: "activeAppStep",
                  },
                },
                _vm._l(
                  _vm.$attrs["v-model"].childrenPlaceholder,
                  function (appStep, index) {
                    return _c(
                      "el-tab-pane",
                      {
                        key: index,
                        attrs: {
                          label: appStep.sectionName,
                          name: appStep.sectionName,
                        },
                      },
                      [
                        _c("app-step", {
                          key: index,
                          attrs: { "v-model": appStep, appSteps: _vm.appSteps },
                        }),
                      ],
                      1
                    )
                  }
                ),
                1
              ),
            ],
            1
          )
        : _c("div", { staticClass: "children" }, [
            _c("p", { staticStyle: { "text-align": "center" } }, [
              _vm._v(" No children "),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "children" }, [
      _c(
        "h5",
        {
          staticStyle: {
            background: "#42b983",
            color: "white",
            padding: "10px 15px",
            "text-align": "center",
          },
        },
        [_vm._v("Child Steps")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }